import React, { useEffect } from 'react';

export function OAuthCallback() {
  useEffect(() => {
    // Envia a URL do callback para a janela pai
    if (window.opener) {
      window.opener.postMessage(window.location.hash, window.location.origin);
      window.close();
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0B1A] text-white flex items-center justify-center">
      <p>Autorizando...</p>
    </div>
  );
}